/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Is Owner For Project By Slug Request Body
 */
export interface InternalIsOwnerForProjectBySlugBody { 
    /**
     * Namespace is the namespace of the subject.
     */
    namespace: InternalIsOwnerForProjectBySlugBody.NamespaceEnum;
    /**
     * ProjectScope is the project_id resolved from the API key.
     */
    project_scope?: string;
    /**
     * ProjectSlug is the project\'s slug.
     */
    project_slug: string;
    /**
     * Subject is the subject acting (user or API key).
     */
    subject: string;
}
export namespace InternalIsOwnerForProjectBySlugBody {
    export type NamespaceEnum = 'User' | ' ApiKey';
    export const NamespaceEnum = {
        User: 'User' as NamespaceEnum,
        ApiKey: ' ApiKey' as NamespaceEnum
    };
}


